// @flow

import _ from 'lodash';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { getTopGrades, getStudies } from 'client/actions';
import type { TopGradesOptions } from 'api';
import { dataLayerEvents } from 'common/utils/analytics';

// import Responsive from 'client/components/common/Responsive';
import Filter, { TYPES } from './Filter';
import Graph from './Graph';
import css from './Top.scss';

// Top (Best|Worth) graph:
// * 10 best|worst cities by selected study for the last year
// * national avg by selected study for the last year

type Props = {
	getTopGrades: (options: TopGradesOptions) => Promise<any>,
	getStudies: () => Promise<any>,
};

const defaultType = TYPES.TOP;

const defaultOptions: TopGradesOptions = {
	study: 'מתמטיקה 5', // editable
	year: '2023', // always last year
};

const defaultData = {};

const shortSubjectList = ['אנגלית 3'];
const top8 = [`היסטוריה לבי"ס דרוזי 2`, `עברית לבי"ס דרוזי 3`];
const bottom8 = [`היסטוריה לבי"ס דרוזי 2`, `עברית לבי"ס דרוזי 3`];
const top9 = [`דת האיסלאם 5`, `דת האיסלאם 2`];
const bottom9 = [`דת האיסלאם 5`, `דת האיסלאם 2`];

function getCityGrades(data, type) {
	const cityGrades = _.get(data, ['cityGrades', type]);
	const field = _.get(data, ['cityGrades', 'field']);

	if (shortSubjectList.includes(field) && type === 'top') {
		return cityGrades.slice(0, 7);
	}

	if (shortSubjectList.includes(field) && type === 'bottom') {
		return cityGrades.slice(4);
	}

	if (top8.includes(field) && type === 'top') {
		return cityGrades.slice(0, 8);
	}

	if (bottom8.includes(field) && type === 'bottom') {
		return cityGrades.slice(2);
	}

	if (top9.includes(field) && type === 'top') {
		return cityGrades.slice(0, 9);
	}

	if (bottom9.includes(field) && type === 'bottom') {
		// return cityGrades.slice(1);
	}

	return cityGrades;
}

// const text = {
// 	title: 'נתוני הבגרויות של ישראל',
// 	titleMobile: 'נתוני הבגרויות של ישראל',
// 	// titleMobile: 'אילו ערים מובילות בציוני בגרויות החובה',
// };

const Top = (props: Props) => {
	const [options, setOptions] = useState(defaultOptions);
	const [type, setType] = useState(defaultType);
	const [data, setData] = useState(defaultData);
	const topRef = useRef(null);
	const observer = useCallback(() => {
		const height = (appRef.current && appRef.current.offsetHeight) || 0;
		const parentHeight = window.innerHeight;
		if (height !== parentHeight && Math.abs(height - parentHeight) > 5) {
			window.parent.postMessage(
				{
					payload: { iframeHeight: height },
					source: 'top-graph',
					type: 'resize',
				},
				'*'
			);
		}
		requestAnimationFrame(observer);
	}, [topRef]);
	const appRef = useRef(null);

	useEffect(() => {
		props.getTopGrades(options).then(setData);

		return () => {};
	}, [props.getTopGrades, options]);

	useEffect(() => {
		dataLayerEvents.onTop();
		if (!appRef.current) {
			appRef.current = document.getElementById('app');
		}
		const rafId = requestAnimationFrame(observer);
		return () => {
			cancelAnimationFrame(rafId);
		};
	}, []);

	const cityGrades = getCityGrades(data, type);
	const nationalGrades = _.get(data, ['nationalGrades']);
	const shouldRenderGraph = cityGrades && nationalGrades;
	return (
		<div className={css.top} ref={topRef}>
			<Filter
				getStudies={props.getStudies}
				onOptionsChange={setOptions}
				onTypeChange={setType}
				currentType={type}
				currentOptions={options}
				setData={setData}
			/>
			{shouldRenderGraph && <Graph data={cityGrades} national={nationalGrades} type={type} />}
		</div>
	);
};

export default connect(null, { getTopGrades, getStudies })(Top);
